import { usePost } from '../../HttpClient';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useCreateMemoCategory() {
  const post = usePost(true, "tms");
  const createMemoCategory = (request: any) =>
    post<{ id: string }>(`${referenceDataBaseUrl}/memo-categories`, request);

  return useMutationWithErrorHandling({
    mutationFn: async (request: any) => await createMemoCategory(request),
  });
}
